import { namespace } from '../model';
import { isOutOfLowerRange } from './is-out-of-lower-range';
import { isOutOfUpperRange } from './is-out-of-upper-range';

export const calculateTooltipPosition = (setPosition, percentilePosition, tooltip, padding) => {
  const container = document.getElementsByClassName(`${namespace}__graph`)[0];
  const bar = document.getElementsByClassName(`${namespace}__bar`)[0];
  const space = document.getElementsByClassName(`${namespace}__space`)[0];
  const tooltipComponent = document.getElementsByClassName(tooltip)[0];
  const spaceBetweenBars = space.offsetWidth;

  if (container && tooltipComponent && bar) {
    const tooltipWidth = tooltipComponent.offsetWidth;
    const barWidth = bar.offsetWidth;

    const initialPosition = padding - barWidth / 2 - spaceBetweenBars;
    const barOffset = Math.trunc(percentilePosition * 10);

    const position = initialPosition + barWidth * barOffset + spaceBetweenBars * barOffset;
    let valuePosition = 0 - tooltipWidth / 2;

    if (isOutOfLowerRange(position, valuePosition)) {
      valuePosition = position * -1;
    } else if (isOutOfUpperRange(position, tooltipWidth, valuePosition, container.offsetWidth)) {
      valuePosition = (tooltipWidth - (container.offsetWidth - position)) * -1;
    }

    // TODO: validar valores NaN
    setPosition({ position, valuePosition, visible: true });
  }
};
